var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-link show-hide",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('i',{class:['af-icons', 'af-icons-' + (_vm.collapsed ? 'preview' : 'read-off')]}),_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }